import { EnvironmentConfig } from './environment-config.model';

const apiBasePath = 'https://michigan.tolstunov.pro/client-api';
const wsBasePath = 'wss://michigan.tolstunov.pro/client-api';

export const environment: EnvironmentConfig = {
  production: false,
  isBermuda: false,
  apiBasePath,
  wsBasePath,
  recaptchaSitekey: '6LdamlYtAAAAAKh9i7YUZGR_BZtCqLT_t-R3taVe',
  googleSsoEnabled: true,
  googleClientId:
    '302174659507-4mr6p8oundc5ngplrtm8apd6pq211lpo.apps.googleusercontent.com',
  coinlionEnabled: true,
  coinlionEmbedUrl: 'https://partner.qa.coinlion.io/embed',
};
